import { Route } from '@modules/husleie-framework/src/types/Route.entity';
import type { AppRoutesState, AppRouteExitData } from '@modules/store/common/types/AppRoutesState.entity';
import { MutationTree } from 'vuex';

export const mutations: MutationTree<AppRoutesState> = {
  setInitialRoutes: (state: AppRoutesState, payload: Route[]) => {
    state.initialRoutes = payload;
  },
  setCurrentActiveRouteByName(state: AppRoutesState, payload: string) {
    let activeRoutes: Route[] = state.initialRoutes.filter((route: Route) => !route.hidden);
    activeRoutes = activeRoutes.map((route, index) => {
      return { ...route, index };
    });
    const currentRoute: undefined | Route = payload
      ? activeRoutes.find((route: Route) => route.name === payload)
      : undefined;
    state.currentRouteIndex = currentRoute ? currentRoute.index : 0;
    state.hideProgressBar = currentRoute ? currentRoute.hideProgressBar : true;
  },
  setNumberOfVisibleRoutesAllowed(state: AppRoutesState, payload: undefined | number) {
    state.numberOfVisibleRoutesAllowed = payload;
  },
  setExitRouteData(state: AppRoutesState, payload: AppRouteExitData) {
    state.exit = { ...state.exit, ...payload };
  },
};
